// extracted by mini-css-extract-plugin
module.exports = {"pagination":"pagination_pagination__3iiHG","active":"pagination_active__2RTWa","item":"pagination_item__1lYTY"};